import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  TimePicker,
} from '@material-ui/pickers';
import ruLocale from "date-fns/locale/pt-BR";

const localeMap = {
  ru: ruLocale,
};

export default function TimePickerCustom(props) {
  const [locale, setLocale] = React.useState("ru");
  const [selectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
      <Grid container justify="space-around">
        <TimePicker
          ampm={false}
          label="Step = 1"
          minutesStep={1}
          {...props}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
}